const upload = {
    dragDrop: 'Drag and drop files here',
    or: 'or',
    selectFiles: 'Select Files',
    uploading: 'Uploading...',
    processing: 'Processing...',
    maxSize: 'Max file size: {{size}}',
    allowedTypes: 'Allowed types: {{types}}',
    duplicateCheck: 'Duplicate Check',
    uploadProgress: 'Upload Progress',
    overallProgress: 'Overall Progress',
    currentFile: 'Current File',
    errors: 'Errors',
    // Upload Page specific
    pageTitle: 'Upload Documents',
    selectDocuments: 'Select Documents to Upload',
    selectDocumentsDesc: 'Drag and drop files here or click to browse.',
    browseFiles: 'Browse Files',
    selectedFiles: 'Selected Files',
    addMetadata: 'Add Document Metadata',
    addMetadataDesc: 'Provide additional information about the documents to improve searchability',
    uploadProgressTitle: 'Upload Progress',
    uploadProgressDesc: 'Your documents are being uploaded and processed',
    uploadComplete: 'Upload Complete!',
    uploadFinishedWithErrors: 'Upload finished with errors',
    uploadFailed: 'Upload failed',
    uploadCompleteDesc: '{{completed}} of {{total}} files uploaded successfully.',
    backgroundProcessingTitle: 'Uploaded; AI processing continues',
    backgroundProcessingMessage: 'Uploaded. AI processing is continuing in the background.',
    backgroundProcessingDesc: 'AI processing is continuing in the background. You can check the status later from the document list or detail page.',
    viewDocuments: 'View Documents',
    // Steps
    steps: {
      selectFiles: 'Select Files',
      addMetadata: 'Add Metadata',
      uploadProcess: 'Upload & Process',
    },
    // Duplicate dialog
    duplicateDetected: 'Duplicate File Detected',
    duplicateWarning: 'A file with the same content already exists in the system.',
    duplicateFileName: 'File name: {{name}}',
    duplicatePrompt: 'A document with the same file name already exists. How would you like to handle it?',
    uploadingFile: 'File to upload:',
    existingFileInfo: 'Existing file information:',
    fileName: 'File name',
    fileSize: 'File size',
    title: 'Title',
    currentVersion: 'Current version',
    uploadedAt: 'Uploaded at',
    newVersionInfo: 'Choosing "Save as new version" keeps the existing file and saves the new file as Version {{version}}.',
    duplicateFile: 'File',
    existingDocument: 'Existing Document',
    cancelUpload: 'Cancel Upload',
    uploadAnyway: 'Upload Anyway',
    replaceExisting: 'Replace Existing',
    saveAsSeparate: 'Save as separate file',
    saveAsNewVersion: 'Save as new version',
    // Navigation
    back: 'Back',
    stepProgress: 'Step {{current}} of {{total}}',
    next: 'Next',
    duplicate: 'Duplicate',
    // Confirmations
    confirmBack: {
      title: 'Go back a step',
      body: 'The metadata you entered will not be saved. Going back discards it and this action cannot be undone. Are you sure you want to go back?',
      confirm: 'Discard and go back',
    },
    confirmLeave: {
      title: 'Leave while uploading?',
      body: 'Files are still uploading. If you leave this page you will lose track of their progress and will not be able to retry any that fail. Are you sure you want to leave?',
      confirm: 'Leave',
    },
    // Dropzone
    dropFilesHere: 'Drop files here',
    dragDropFiles: 'Drag & Drop files here',
    orClickToBrowse: 'or click to browse your computer',
    limitsTitle: 'What you can upload',
    limitsLoading: 'Checking the formats and limits that apply to you…',
    limitsUnavailable: 'The formats and limits could not be loaded. Uploading is unavailable until they are.',
    limitsFormats: 'Accepted formats: {{types, list}}',
    csvScope: 'CSV: comma-separated UTF-8, CP932 or BOM-marked UTF-16. Content ingestion supports up to 10 MiB, 10,000 rows, 1,000 columns and 100,000 cells.',
    xlsmScope: 'XLSM: saved cell values only; no macro execution, recalculation or preview. Content ingestion supports up to 10 MiB, 100 sheets, 10,000 rows and 1,000 columns per sheet, and 100,000 cells in total.',
    limitsMaxSize: 'Maximum per file: {{size}} MB',
    limitsMaxFiles: 'Files at once: {{count}}',
    maxFiles: 'Maximum files: {{count}}',
    maxFilesError: 'Maximum {{count}} files allowed',
    fileSizeError: '{{name}}: File size exceeds {{size}}MB limit',
    fileTypeError: '{{name}}: Unsupported file type. Allowed: {{types}}',
    progressTracker: {
      overallProgress: 'Overall Progress',
      fileProgress: 'File Progress',
      completedCount: '{{count}} Completed',
      failedCount: '{{count}} Failed',
      fileDetails: 'File Details',
      fileSize: 'File Size:',
      fileType: 'File Type:',
      progress: 'Progress:',
      metadata: 'Metadata',
      category: 'Category:',
      description: 'Description:',
    },
    status: {
      pending: 'Waiting...',
      uploading: 'Uploading... {{progress}}%',
      processing: 'Processing...',
      completed: 'Completed',
      error: 'Failed',
      duplicate: 'Duplicate file',
      unknown: 'Unknown',
    },
  };

export default upload;
